import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedReorder202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_reorder_202604",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 12451,
  clicks: 259,
  adsSpendDollars: 904,
  budgetDollars: 1000,
  salesDollars: 9169,
  bestEstimateRoas: 10.14,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.9,
  reorderConversions: 40,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
